import styled from 'styled-components';

export const SliderRoot = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 4px;
  border: 1px solid var(--neutral-4);
  overflow: hidden;
  cursor: ew-resize;
  touch-action: none;
  user-select: none;
  background-color: var(--secondary-5);

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
    -webkit-user-drag: none;
  }
`;

export const BeforeImage = styled.img<{ $position: number }>`
  clip-path: inset(0 ${(props) => 100 - props.$position}% 0 0);
  z-index: 1;
`;

export const Divider = styled.div<{ $position: number }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${(props) => props.$position}%;
  z-index: 2;
  width: 2px;
  background: #fff;
  transform: translateX(-50%);
  pointer-events: none;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
`;

export const Handle = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  transform: translate(-50%, -50%);
  color: rgba(0, 0, 0, 0.65);
  font-size: 12px;
  line-height: 1;

  .anticon {
    font-size: 10px;
  }
`;

export const Label = styled.span<{ $side: 'before' | 'after' }>`
  position: absolute;
  z-index: 3;
  bottom: 8px;
  ${(props) => (props.$side === 'before' ? 'left: 8px;' : 'right: 8px;')}
  padding: 2px 8px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  pointer-events: none;
`;
